// extracted by mini-css-extract-plugin
export default {"question":"InputDate_question__Z0Ws8","input":"InputDate_input__SLUKH"};